import { theme } from './theme';

/**
 * Hook to access theme colors
 * 
 * Usage:
 *   const { primary, text, background } = useTheme();
 */
export function useTheme() {
  return theme;
}
